import { useQuery } from '@tanstack/react-query';

import { scheduleKeys } from '@/hooks/schedule/scheduleKeys';
import { getPrintSchedule } from '@/infrastructure/network/data/schedule/schedule';

export const usePrintScheduleQuery = (eventId: string | undefined, useSessions?: boolean, printSidebarOpen?: boolean) => {
	const shouldEnable = !!eventId && printSidebarOpen;
	return useQuery({
		queryKey: scheduleKeys.printSchedule(eventId, useSessions),
		queryFn: () => getPrintSchedule({ eventId: eventId, useSessions }),
		enabled: shouldEnable,
		// Keep data fresh for 5 minutes to avoid refetching on quick session/type toggles
		staleTime: 5 * 60 * 1000,
		// Don't refetch on tab focus to prevent UI flicker and noisy network calls in dev
		refetchOnWindowFocus: false
	});
};
